/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description compareUrls
 */

/**
 * compare two urls for equality. decodeURI both and normalize + vs %20
 *
 * @param {string} left
 * @param {string} right
 * @returns {boolean} true if they are the same
 */
export const compareUrls = (left: string, right: string) => {
  try {
    return (
      decodeURIComponent(left).replace(/[+]/g, ' ') ===
      decodeURIComponent(right).replace(/[+]/g, ' ')
    )
  } catch {
    return left === right
  }
}
